import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export const vnDay = (offset = 0) => new Date(Date.now() + 7 * 3600_000 + offset * 86_400_000).toISOString().slice(0, 10);

/** Điểm kho đã làm đủ: đã xác nhận Đủ, có ảnh xuất hàng, không còn hàng bổ sung chưa soạn (điểm hàng về đơn mua chỉ cần đã nhận) */
export const stopDone = (r: { kind: string; pickedAt: string | null; exportPhotos: number; amendments: unknown[] }) =>
  !!r.pickedAt && (r.kind !== 'warehouse' || r.exportPhotos > 0) && !r.amendments.length;

/**
 * Số điểm soạn hàng hôm nay chưa xong (nút Soạn hàng ở thanh dưới, anh Tiến 20/10/2026). Thông báo kho tới thì tải lại ngay (NotificationProvider).
 * Anh Tiến 26/10/2026 "ngày nào chỉ hiển thị các đơn ngày đó thôi": chỉ đếm đơn của hôm nay (ngày SO3), không gộp đơn ngày trước.
 */
export function usePickOpenCount(enabled: boolean) {
  const q = useQuery({
    queryKey: ['pick-queue', 'badge'],
    queryFn: () =>
      api.get<{ kind: string; pickedAt: string | null; exportPhotos: number; amendments: unknown[] }[]>('/deliveries/pick-queue', {
        dateFrom: vnDay(0),
        dateTo: vnDay(0),
        lite: true,
      }),
    enabled,
    refetchInterval: 60_000,
  });
  return q.data?.filter((r) => !stopDone(r)).length ?? 0;
}
